import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from 'axios';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: "leaveBalanceEdit",
  mixins: [validationMixin],
  components: {
    MainLayout,
    flatPickr,
    Loading,
    CONFIG
  },

  data() {
    return {
      CONFIG,
      isLoading: false,
      noDataFound: false,
      formData: {
        employee_no: '',
        employee_name: '',
        annual_leave: '',
        casual_leave: '',
        sick_leave: '',
        annual_received_date: null,
        casual_received_date: null,
        sick_received_date: null,
        owner_id: '',
        owner_type: '',
        join_date: '',
      },
      submitted: false,
      disabled: false,
    };
  },

  validations() {
    const notGreaterThanToday = (value) => {
      if (!value) return true;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(value);
      selectedDate.setHours(0, 0, 0, 0);
      return selectedDate <= today;
    };

    const notBeforeJoinDate = (value) => {
      if (!value) return true;
      if (!this.formData.join_date) return true; 
      const joinDate = new Date(this.formData.join_date);
      joinDate.setHours(0, 0, 0, 0);
      const selectedDate = new Date(value);
      selectedDate.setHours(0, 0, 0, 0);
      return selectedDate >= joinDate;
    };

    return {
      formData: {
        annual_received_date: { required, notGreaterThanToday, notBeforeJoinDate },
        casual_received_date: { required, notGreaterThanToday, notBeforeJoinDate },
        sick_received_date: { required, notGreaterThanToday, notBeforeJoinDate }
      }
    };
  },

  methods: {
    getLeaveBalanceDetail() {
      this.isLoading = true;
      const params = {
        owner_id: this.$route.params.owner_id,
        owner_type: this.$route.params.owner_type,
      };
      axios.get('/leave-balance/detail', {
        params
      })
        .then((response) => {
          this.noDataFound = false;
          const data = response.data;
          this.formData.owner_id = data.owner_id;
          this.formData.owner_type = data.owner_type;
          this.formData.employee_no = data.employee_no;
          this.formData.employee_name = data.employee_name;
          this.formData.annual_leave = data.annual_leave;
          this.formData.casual_leave = data.casual_leave;
          this.formData.sick_leave = data.sick_leave;
          this.formData.annual_received_date = data.annual_received_date;
          this.formData.casual_received_date = data.casual_received_date;
          this.formData.sick_received_date = data.sick_received_date;
          this.formData.join_date = data.join_date;
        })
        .catch((err) => {
          const status = err && err.response && err.response.status;

          if (status === 401 && err.response.data && err.response.data.message === 'Unauthenticated.') {
            this.$store.commit('logout');
            window.location.replace('login');
            return;
          }

          if (status === 403 || status === 400) {
            this.noDataFound = true;
            this.formData = {
              employee_no: '',
              employee_name: '',
              annual_leave: '',
              casual_leave: '',
              sick_leave: '',
              annual_received_date: null,
              casual_received_date: null,
              sick_received_date: null,
              owner_id: '',
              owner_type: ''
            };
            return;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateLeaveBalance() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }
      this.disabled = true;
      this.isLoading = true;
      axios.put('/leave-balance/update', {
        owner_id: this.formData.owner_id,
        owner_type: this.formData.owner_type,
        annual_received_date: this.formData.annual_received_date,
        casual_received_date: this.formData.casual_received_date,
        sick_received_date: this.formData.sick_received_date,
        join_date: this.formData.join_date
      })
        .then((response) => {
          if (response.data.success) {
            this.$notification.success("Leave balance updated successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "leaveBalanceList"
            });
          } else {
            this.disabled = false;
            this.$notification.error('Failed to update leave balance.', {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    cancel() {
      this.$router.push({ name: 'leaveBalanceList' });
    }
  },

  mounted() {
    this.getLeaveBalanceDetail();
  },
};
